import { CandidatStatusOnMission, MissionStatusEnum } from '../enums';
import { GenericCharge } from '../../../models/GenericCharge';

export const EtablissementData = {
  mission: {
    duplicate: {
      title: 'Duplication de la mission',
      description: 'Êtes-vous sûr(e) de vouloir dupliquer cette mission ?',
      secondButton: 'Annuler',
      primaryButton: 'Dupliquer',
    },
    archive: {
      title: 'Annuler la mission',
      description: 'Êtes-vous sûr(e) de vouloir annuler cette offre ?',
      secondButton: 'Non',
      primaryButton: 'Oui',
    },

    cancelRequest: {
      title: `Accepter l'annulation de la candidature`,
      description:
        "Êtes-vous sûr(e) de vouloir accepter la demande d'annulation de la candidature après l'annulation du contrat ?",
      secondButton: 'Non',
      primaryButton: 'Oui',
    },
    deleteMission: {
      title: 'Confirmation',
      description:
        'Êtes-vous sûr(e) de supprimer cette mission ? Cette action la supprimera définitivement.',
      secondButton: 'Annuler',
      primaryButton: 'Supprimer',
    },
    signContractReminder: {
      title: 'Envoyer un rappel pour signer le contrat',
      description:
        "Êtes-vous sûr(e) d'envoyer un rappel pour signer le contrat. Un rappel est autorisé chaque 24 heures",
      secondButton: 'Annuler',
      primaryButton: 'Envoyer',
    },
    validateMissionReminder: {
      title: "Envoyer un rappel à l'établissement pour valider la mission",
      description:
        "Êtes-vous sûr(e) d'envoyer un rappel à l'établissement pour valider la mission. Un rappel est autorisé chaque 24 heures",
      secondButton: 'Annuler',
      primaryButton: 'Envoyer',
    },
    cancelCandidacy: {
      title: 'Annuler la candidature',
      description:
        "Êtes-vous sûr(e) de vouloir annuler cette candidature ?",
      secondButton: 'Non',
      primaryButton: 'Oui',
    },
    motifRefus: {
      title: "Motif de refus par l'établissement",
      description: "",
      secondButton: '',
      primaryButton: 'Fermer',
    },
    cancelPendingMission: {
      title: 'Annuler une offre de mission',
      description:
        "Êtes-vous sûr(e) de vouloir annuler cette offre ?",
      secondButton: 'Non',
      primaryButton: 'Oui',
    },
  },
  monEtablissement: {
    titleVerificationDialog: 'Quitter sans sauvegarder?',
    descriptionVerificationDialog:
      'Vous avez apporté des modifications aux détails de votre établissement, mais vous vous apprêtez à quitter la page sans sauvegarder. Toutes les modifications seront perdues. Êtes-vous sûr(e) de vouloir quitter sans sauvegarder ?',
    fistLabelVerificationDialog: 'Revenir à la Modification',
    secondLabelVerificationDialog: 'Quitter sans Sauvegarder',
    successEtablissementUpdate:
      'Les détails de votre établissement ont été mis à jour!',
    hideStatusDialog: {
      title: 'Confirmation',
      description:
        'Êtes-vous sûr(e) de vouloir masquer votre site ? Cette action le rendra indisponible aux candidats et toutes les informations associées ne seront plus visibles. Vous pourrez réactiver le site à tout moment dans les paramètres si besoin.',
      secondButton: 'Annuler',
      primaryButtonHide: 'Masquer le site',
      primaryButtonShow: 'Afficher le site',
    },
    deletePersonDialog: {
      title: 'Confirmation',
      description:
        'Êtes-vous sûr(e) de vouloir supprimer cette personne ? Cette action la supprimera définitivement.',
      secondButton: 'Annuler',
      primaryButton: 'Supprimer',
    },
    deleteAgenceDialog: {
      title: 'Confirmation',
      description:
        'Êtes-vous sûr(e) de vouloir supprimer cette agence ? Cette action la supprimera définitivement.',
      secondButton: 'Annuler',
      primaryButton: 'Supprimer',
    },
    photoDescription:
      'Ajouter des photos du site offre aux candidats une vision\n' +
      'concrète de votre établissement, facilitant ainsi leur compréhension de\n' +
      "l'environnement professionnel que vous proposez. Les annonces avec photos\n" +
      'rencontrent plus de succès sur notre plateforme. Ceci augmente vos chances de\n' +
      'trouver un professionnel.',
    addAfter: 'Vous pouvez les ajouter ulérieurement.',
  },
};
export const EtablissmentTypes = [
  { label: 'Etablissement public MCO', value: 1 },
];
export const etablissementType = [
  { value: 'CP-MCO', label: 'Établissement public MCO' },
  { value: 'CP-MCOS', label: 'Clinique Privée' },
  // {value : "Hôpital Universitaire", label : "Hôpital Universitaire"},
  // {value : "Centre de Soins de Longue Durée (CSLD)", label : "Centre de Soins de Longue Durée (CSLD)"},
  // {value : "Centre de Rééducation et de Réadaptation", label : "Centre de Rééducation et de Réadaptation"},
  // {value : "Centre de Soins Palliatifs", label : "Centre de Soins Palliatifs"},
  // {value : "Centre de Psychiatrie", label : "Centre de Psychiatrie"},
];
export const salaryNumber = [
  { value: 50, label: '10 - 50' },
  { value: 100, label: '50 - 100' },
  { value: 500, label: '100 - 500' },
  { value: 1000, label: '500 - 1000' },
  { value: 2000, label: 'Plus de 1000' },
];

export const annuelNumber = [
  { value: 100, label: '50 - 100' },
  { value: 500, label: '100 - 500' },
  { value: 1000, label: '500 - 1000' },
  { value: 2000, label: '1000 - 2000' },
  { value: 3000, label: 'Plus de 2000' },
];

export const menuAddress = [
  {
    id: 1,
    label: 'Définir comme siège social',
    icon: 'building-black-stroke.svg',
  },
  { id: 2, label: 'Modifier', icon: 'edit-black.svg' },
  { id: 3, label: 'Masquer ce site', icon: 'no-visible-black.svg' },
  { id: 4, label: 'Afficher ce site', icon: 'visible.svg' },
];

export const contratMission = [
  { value: 0, label: 'Cdi' },
  { value: 1, label: 'Cdd' },
  { value: 2, label: 'Liberal' },
];
export const fonctionOptions = [
  { value: '1', label: 'Secrétaire général' },
  { value: '2', label: 'Inférmier' },
  { value: '3', label: 'Docteur' },
];
export const civilityOptions = [
  { value: 'MONSIEUR', label: 'Mr' },
  { value: 'MADAME', label: 'Mme' },
  // { value: 'Ms', label: 'Ms' },
  // { value: 'Miss', label: 'Miss' },
  // { value: 'Dr', label: 'Dr' },
  // { value: 'Pr', label: 'Pr' },
];
export const civilityForProfileOptions = [
  { value: 'MONSIEUR', label: 'Mr' },
  { value: 'MADAME', label: 'Mme' },
  { value: 'Ms', label: 'Ms' },
  { value: 'Miss', label: 'Miss' },
  { value: 'Dr', label: 'Dr' },
  { value: 'Pr', label: 'Pr' },
];
export const domaineOptions = [
  { value: 'service', label: 'Service' },
  { value: 'pharmaceutique', label: 'Pharmaceutique' },
  { value: 'medical', label: 'Medical' },
];

export const statusMissionOptions = [
  { value: 1, label: 'Publiée' },
  { value: 2, label: 'Non publiée' },
  // , {value: 3, label: "Medical"}
];

export const priorityMissionOptions = [
  { value: false, label: 'Normale', icon: 'assets/icons/greenFlag.svg' },
  { value: true, label: 'Urgente', icon: 'assets/icons/redFlag.svg' },
];

export const typeContratOptions = [
  { value: 'LIBERAL', label: 'Intérim' },
  { value: 'CDD', label: 'CDD' },
  { value: 'CDI', label: 'CDI' },
];

export const acceptationCandidantOptions = [
  { value: 1, label: 'Automatique' },
  { value: 2, label: 'Manuelle' },
];
export const registerNationalityOptions = [
  { label: 'Française', value: 'Française' },
  {
    label: `Ressortissant d'un pays de l’union européenne ou de la Suisse`,
    value: 'européenne',
  },
  { label: `Nationalité hors union européenne et Suisse`, value: 'autre' },
];
export const nationalityOptions = [
  { label: 'Afghan', value: 'afghan' },
  { label: 'Albanais', value: 'albanais' },
  { label: 'Algérien', value: 'algérien' },
  { label: 'Allemand', value: 'allemand' },
  { label: 'Andorran', value: 'andorran' },
  { label: 'Angolais', value: 'angolais' },
  { label: 'Antiguais-et-Barbudien', value: 'antiguais-et-barbudien' },
  { label: 'Argentin', value: 'argentin' },
  { label: 'Arménien', value: 'arménien' },
  { label: 'Australien', value: 'australien' },
  { label: 'Autrichien', value: 'autrichien' },
  { label: 'Azerbaïdjanais', value: 'azerbaïdjanais' },
  { label: 'Bahaméen', value: 'bahaméen' },
  { label: 'Bahreïni', value: 'bahreïni' },
  { label: 'Bangladais', value: 'bangladais' },
  { label: 'Barbadien', value: 'barbadien' },
  { label: 'Biélorusse', value: 'biélorusse' },
  { label: 'Belge', value: 'belge' },
  { label: 'Bélizien', value: 'bélizien' },
  { label: 'Béninois', value: 'béninois' },
  { label: 'Bhoutanais', value: 'bhoutanais' },
  { label: 'Bolivien', value: 'bolivien' },
  { label: 'Bosniaque', value: 'bosniaque' },
  { label: 'Botswanais', value: 'botswanais' },
  { label: 'Brésilien', value: 'brésilien' },
  { label: 'Britannique', value: 'britannique' },
  { label: 'Bruneien', value: 'bruneien' },
  { label: 'Bulgare', value: 'bulgare' },
  { label: 'Burkinabè', value: 'burkinabè' },
  { label: 'Burundais', value: 'burundais' },
  { label: 'Cambodgien', value: 'cambodgien' },
  { label: 'Camerounais', value: 'camerounais' },
  { label: 'Canadien', value: 'canadien' },
  { label: 'Cap-Verdien', value: 'cap-verdien' },
  { label: 'Centrafricain', value: 'centrafricain' },
  { label: 'Chilien', value: 'chilien' },
  { label: 'Chinois', value: 'chinois' },
  { label: 'Chypriote', value: 'chypriote' },
  { label: 'Colombien', value: 'colombien' },
  { label: 'Comorien', value: 'comorien' },
  { label: 'Congolais', value: 'congolais' },
  { label: 'Costaricain', value: 'costaricain' },
  { label: 'Croate', value: 'croate' },
  { label: 'Cubain', value: 'cubain' },
  { label: 'Danois', value: 'danois' },
  { label: 'Djiboutien', value: 'djiboutien' },
  { label: 'Dominicain', value: 'dominicain' },
  { label: 'Dominiquais', value: 'dominiquais' },
  { label: 'Égyptien', value: 'égyptien' },
  { label: 'Émirati', value: 'émirati' },
  { label: 'Équato-guinéen', value: 'équato-guinéen' },
  { label: 'Érythréen', value: 'érythréen' },
  { label: 'Espagnol', value: 'espagnol' },
  { label: 'Estonien', value: 'estonien' },
  { label: 'Éthiopien', value: 'éthiopien' },
  { label: 'Fidjien', value: 'fidjien' },
  { label: 'Finlandais', value: 'finlandais' },
  { label: 'Français', value: 'français' },
  { label: 'Gabonais', value: 'gabonais' },
  { label: 'Gambien', value: 'gambien' },
  { label: 'Géorgien', value: 'géorgien' },
  { label: 'Ghanéen', value: 'ghanéen' },
  { label: 'Grec', value: 'grec' },
  { label: 'Grenadien', value: 'grenadien' },
  { label: 'Guatémaltèque', value: 'guatémaltèque' },
  { label: 'Guinéen', value: 'guinéen' },
  { label: 'Guyanais', value: 'guyanais' },
  { label: 'Haïtien', value: 'haïtien' },
  { label: 'Hondurien', value: 'hondurien' },
  { label: 'Hongrois', value: 'hongrois' },
  { label: 'Indien', value: 'indien' },
  { label: 'Indonésien', value: 'indonésien' },
  { label: 'Irakien', value: 'irakien' },
  { label: 'Iranien', value: 'iranien' },
  { label: 'Irlandais', value: 'irlandais' },
  { label: 'Islandais', value: 'islandais' },
  { label: 'Israélien', value: 'israélien' },
  { label: 'Italien', value: 'italien' },
  { label: 'Ivoirien', value: 'ivoirien' },
  { label: 'Jamaïcain', value: 'jamaïcain' },
  { label: 'Japonais', value: 'japonais' },
  { label: 'Jordanien', value: 'jordanien' },
  { label: 'Kazakh', value: 'kazakh' },
  { label: 'Kenyan', value: 'kenyan' },
  { label: 'Kirghiz', value: 'kirghiz' },
  { label: 'Kiribatien', value: 'kiribatien' },
  { label: 'Kittitien-et-Névicien', value: 'kittitien-et-névicien' },
  { label: 'Kosovar', value: 'kosovar' },
  { label: 'Koweïtien', value: 'koweïtien' },
  { label: 'Laotien', value: 'laotien' },
  { label: 'Lesothan', value: 'lesothan' },
  { label: 'Lettone', value: 'lettone' },
  { label: 'Libanais', value: 'libanais' },
  { label: 'Libérien', value: 'libérien' },
  { label: 'Libyen', value: 'libyen' },
  { label: 'Liechtensteinois', value: 'liechtensteinois' },
  { label: 'Lituanien', value: 'lituanien' },
  { label: 'Luxembourgeois', value: 'luxembourgeois' },
  { label: 'Macédonien', value: 'macédonien' },
  { label: 'Malagasy', value: 'malagasy' },
  { label: 'Malaisien', value: 'malaisien' },
  { label: 'Malawien', value: 'malawien' },
  { label: 'Maldivien', value: 'maldivien' },
  { label: 'Malien', value: 'malien' },
  { label: 'Maltais', value: 'maltais' },
  { label: 'Marocain', value: 'marocain' },
  { label: 'Marshallais', value: 'marshallais' },
  { label: 'Mauricien', value: 'mauricien' },
  { label: 'Mauritanien', value: 'mauritanien' },
  { label: 'Mexicain', value: 'mexicain' },
  { label: 'Micronésien', value: 'micronésien' },
  { label: 'Moldave', value: 'moldave' },
  { label: 'Monégasque', value: 'monégasque' },
  { label: 'Mongol', value: 'mongol' },
  { label: 'Monténégrin', value: 'monténégrin' },
  { label: 'Mozambicain', value: 'mozambicain' },
  { label: 'Namibien', value: 'namibien' },
  { label: 'Nauruan', value: 'nauruan' },
  { label: 'Néerlandais', value: 'néerlandais' },
  { label: 'Néo-Zélandais', value: 'néo-zélandais' },
  { label: 'Népalais', value: 'népalais' },
  { label: 'Nicaraguayen', value: 'nicaraguayen' },
  { label: 'Nigérian', value: 'nigérian' },
  { label: 'Nigérien', value: 'nigérien' },
  { label: 'Norvégien', value: 'norvégien' },
  { label: 'Omanais', value: 'omanais' },
  { label: 'Ougandais', value: 'ougandais' },
  { label: 'Ouzbek', value: 'ouzbek' },
  { label: 'Pakistanais', value: 'pakistanais' },
  { label: 'Palaosien', value: 'palaosien' },
  { label: 'Palestinien', value: 'palestinien' },
  { label: 'Panaméen', value: 'panaméen' },
  { label: 'Papouan-Néo-Guinéen', value: 'papouan-néo-guinéen' },
  { label: 'Paraguayen', value: 'paraguayen' },
  { label: 'Péruvien', value: 'péruvien' },
  { label: 'Philippin', value: 'philippin' },
  { label: 'Polonais', value: 'polonais' },
  { label: 'Portugais', value: 'portugais' },
  { label: 'Qatarien', value: 'qatarien' },
  { label: 'Roumain', value: 'roumain' },
  { label: 'Russe', value: 'russe' },
  { label: 'Rwandais', value: 'rwandais' },
  { label: 'Saint-Lucien', value: 'saint-lucien' },
  { label: 'Saint-Marinais', value: 'saint-marinais' },
  {
    label: 'Saint-Vincentais-et-Grenadin',
    value: 'saint-vincentais-et-grenadin',
  },
  { label: 'Salomonais', value: 'salomonais' },
  { label: 'Salvadorien', value: 'salvadorien' },
  { label: 'Samoan', value: 'samoan' },
  { label: 'Santoméen', value: 'santoméen' },
  { label: 'Saoudien', value: 'saoudien' },
  { label: 'Sénégalais', value: 'sénégalais' },
  { label: 'Serbe', value: 'serbe' },
  { label: 'Seychellois', value: 'seychellois' },
  { label: 'Sierra-Léonais', value: 'sierra-léonais' },
  { label: 'Singapourien', value: 'singapourien' },
  { label: 'Slovaque', value: 'slovaque' },
  { label: 'Slovène', value: 'slovène' },
  { label: 'Somalien', value: 'somalien' },
  { label: 'Soudanais', value: 'soudanais' },
  { label: 'Sri-Lankais', value: 'sri-lankais' },
  { label: 'Sud-Coréen', value: 'sud-coréen' },
  { label: 'Sud-Soudanais', value: 'sud-soudanais' },
  { label: 'Surinamien', value: 'surinamien' },
  { label: 'Suédois', value: 'suédois' },
  { label: 'Suisse', value: 'suisse' },
  { label: 'Swazi', value: 'swazi' },
  { label: 'Syrien', value: 'syrien' },
  { label: 'Tadjik', value: 'tadjik' },
  { label: 'Tanzanien', value: 'tanzanien' },
  { label: 'Tchadien', value: 'tchadien' },
  { label: 'Tchèque', value: 'tchèque' },
  { label: 'Thaïlandais', value: 'thaïlandais' },
  { label: 'Timorais', value: 'timorais' },
  { label: 'Togolais', value: 'togolais' },
  { label: 'Tonguien', value: 'tonguien' },
  { label: 'Trinidadien', value: 'trinidadien' },
  { label: 'Tunisien', value: 'tunisien' },
  { label: 'Turkmène', value: 'turkmène' },
  { label: 'Turc', value: 'turc' },
  { label: 'Tuvaluan', value: 'tuvaluan' },
  { label: 'Ukrainien', value: 'ukrainien' },
  { label: 'Uruguayen', value: 'uruguayen' },
  { label: 'Vanuatais', value: 'vanuatais' },
  { label: 'Vénézuélien', value: 'vénézuélien' },
  { label: 'Vietnamien', value: 'vietnamien' },
  { label: 'Yéménite', value: 'yéménite' },
  { label: 'Zambien', value: 'zambien' },
  { label: 'Zimbabwéen', value: 'zimbabwéen' },
];
export const filterList = [
  {
    label: 'Totalement affectée',
    value: CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH,
  },
    {
    label: 'Acceptée',
    value: CandidatStatusOnMission.ACCEPTED,
  },
  { label: 'Publiée en attente', value: CandidatStatusOnMission.PENDING },
  {
    label: 'Brouillon',
    value: MissionStatusEnum.DRAFT,
  },
];

export const filterListDone = [
  {
    label: 'Totalement Validée', value: MissionStatusEnum.VALIDATED,
  },
  {
    label: 'En attente de validation',
    value: MissionStatusEnum.PENDING
  },
];

export const filterListDoneInterim = [
  {
    label: 'Validée',
    value: MissionStatusEnum.VALIDATED,
  },
  {
    label: 'Validation refusée',
    value: MissionStatusEnum.INVALIDATED
  },
  {
    // mission terminée AFFECTÉE (contrat signé) dont la validation est en attente — et non plus « toutes les missions PENDING »
    label: 'En attente de validation',
    value: 'AWAITING_VALIDATION'
  },
  {
    // mission terminée sans aucun professionnel affecté (annulée, non signée, sans candidat) : rien à valider
    label: 'Terminée sans affectation',
    value: 'NOT_ASSIGNED'
  }
];

export const filterListForCandidate = [
  {
    label: 'Contrat en attente de validation',
    value: CandidatStatusOnMission.CONTRACT_PENDING_VALIDATION,
  },
  {
    label: 'Totalement affectée',
    value: CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH,
  },
  {
    label: 'Acceptée',
    value: CandidatStatusOnMission.ACCEPTED,
  },
  {
    label: 'Candidature annulée par vous',
    value: CandidatStatusOnMission.CANCELED_BY_INTERIM_AGENCY,
  },
  {
    label: 'Candidature annulée',
    value: CandidatStatusOnMission.CANCELED_BY_CANDIDATE,
  },
  {
    label: 'Candidature en attente',
    value: CandidatStatusOnMission.CANDIDAT_APPLIED_ON_THIS_MISSION,
  },
  {
    label: 'Candidature refusée',
    value: CandidatStatusOnMission.REJECTED,
  }
];

export const FraisPostList: GenericCharge[] = [
  {
    id: 1,
    type: 'checkbox',
    controlName: 'childrenunderone',
    label: "Enfants de moins d'un an",
    display: true,
    isSecond: false,
  },
  {
    id: 2,
    type: 'checkbox',
    controlName: 'childrenagedonetothree',
    label: 'Enfants agés de 1 à 3 ans',
    display: true,
    isSecond: false,
  },
  {
    id: 3,
    type: 'checkbox',
    controlName: 'childrenagedthreetoten',
    label: 'Enfants agés de 3 à 10 ans',
    display: true,
    isSecond: false,
  },
  {
    id: 4,
    type: 'checkbox',
    controlName: 'patientsinorlsurgery',
    label: 'Patients en chirurgie ORL',
    display: true,
    isSecond: false,
  },
  {
    id: 5,
    type: 'checkbox',
    controlName: 'patientsincardiacsurgery',
    label: 'Patients en chirurgie cardiaque',
    display: true,
    isSecond: false,
  },
  {
    id: 6,
    type: 'checkbox',
    controlName: 'patientsinneurocerebralsurgery',
    label: 'Patients en neurochirurgie cérébrale',
    display: true,
    isSecond: false,
  },
];

export const ChargeList: GenericCharge[] = [
  {
    id: 1,
    type: 'checkbox',
    controlName: 'isaccommodationprovidedbyestablishment',
    label: 'Hébergement',
    display: true,
    isSecond: false,
  },
  {
    id: 3,
    type: 'radio',
    options: [
      { label: 'Au sein de l’établissement', value: false },
      { label: 'Extérieur (Hôtel ou location)', value: true },
    ],
    controlName: 'isaccommodationprovidedfromexterior',
    label: 'Prise en charge',
    display: false,
    isSecond: true,
  },
  {
    id: 2,
    type: 'textarea',
    controlName: 'accommodationconditions',
    label: 'Conditions de prise en charge',
    display: false,
    isSecond: true,
  },

  {
    id: 4,
    type: 'checkbox',
    controlName: 'ismealsprovidedbyestablishment',
    label: 'Repas',
    display: true,
    isSecond: false,
  },
  {
    id: 8,
    type: 'radio',
    options: [
      { label: 'Au sein de l’établissement', value: false },
      { label: 'Extérieur (restaurants et commerces)', value: true },
    ],
    controlName: 'ismealsprovidedfromexterior',
    label: 'Prise en charge',
    display: false,
    isSecond: true,
  },
  {
    id: 9,
    type: 'textarea',
    controlName: 'mealsconditions',
    label: 'Conditions de prise en charge',
    display: false,
    isSecond: true,
  },

  {
    id: 5,
    type: 'checkbox',
    controlName: 'istakinginchargetravelingexpenses',
    label: 'Frais de déplacement',
    display: true,
    isSecond: false,
  },
  {
    id: 10,
    type: 'textarea',
    controlName: 'travelingconditions',
    label: 'Conditions de prise en charge',
    display: false,
    isSecond: true,
  },

  {
    id: 6,
    type: 'checkbox',
    controlName: 'isprimeprovided',
    label: 'Prime d’installation',
    display: false,
    isSecond: false,
  },
  {
    id: 7,
    type: 'checkbox',
    controlName: 'isthirteenthmonthprovided',
    label: 'Treizième mois',
    display: false,
    isSecond: false,
  },

  // {
  //   id: 11,
  //   type: 'checkbox',
  //   controlName: 'isotherprimeprovided',
  //   label:
  //     'Existe-t-il autres primes ou indemnités mensuelles ou annuelles en euros ? ',
  //   display: false,
  //   isSecond: false,
  // },
  // {
  //   id: 12,
  //   type: 'textarea',
  //   controlName: 'otherprimesconditions',
  //   label: 'Autres conditions',
  //   display: false,
  //   isSecond: true,
  // },
];
